import Config from "./Config"

class GA {
  constructor () {
    this.debugPaths = ['local', 'still', ]
    this.debug = this.debugPaths.some(path => {
      return window.location.host.includes(path)
    })
    this.debug = this.debug || Config.isDebug()
    this.action = 'MobileGame'
  }
  trackEvent(category, label, value = 1) {
    // if (!Config.isProd()) {
    //   console.log('Debug GA:trackEvent', {action,category,label,value})
    //   return
    // }
    if(!this.debug && window.gtag) {
      window.gtag('event', this.action, {
        'event_category': category,
        'event_label':label,
        'value': value,
      })
    } else {
      console.log('Debug GA:trackEvent', {category,label,value})
    }
  }
  
  trackScreen(screenName) {
    this.trackEvent('View', screenName)
  }
}

export default new GA()